import { Dialog, DialogContent, Button, DialogActions, DialogContentText } from "@mui/material";
import React, { Fragment, useContext, useState } from "react";

import { SessionContext } from "../../utility/useSession";
import propTypes from "prop-types";
import TextInputField from "../editable/EditableField/fields/TextInputField";
import { api } from "../../logic/api";
import ErrorDialog from "../notifications/errorDialog/ErrorDialog";
import { ProgressView } from "../notifications/progress/ProgressView";
import { Trans, useTranslation } from "react-i18next";

enum TwoFactorStatus {
  register = 0,
  confirmCode = 1,
  finish = 2
}

const TwoFactorRegistration: React.FunctionComponent<{
  show: boolean;
  onClose: () => void;
}> = (props) => {
  const session = useContext(SessionContext);
  const { t } = useTranslation();
  let twoFactorRequired = false;
  let currentSite = "";

  if (session.current.site) {
    if (session.current.site.home != null) {
      if (session.current.credential != null) {
        currentSite = session.current.credential.database;
      }
      currentSite = `${currentSite} (${session.current.site.home.name})`;
    }
    if (session.current.site.preferences.two_factor_required == true) {
      if (session.current.credential) {
        if (session.current.credential.twoFactorEnabled != true) {
          twoFactorRequired = true;
        }
      }
    }
  }

  const [status, setStatus] = useState<TwoFactorStatus>(TwoFactorStatus.register);
  const [mobile, setMobile] = useState("");
  const [code, setCode] = useState("");

  const sendTwoFactor = api.hooks.twoFactor.sendTwoFactorActivation();
  const confirmTwoFactor = api.hooks.twoFactor.confirmTwoFactorActivation();


  return <Dialog
    maxWidth={"sm"}

    open={props.show}
    keepMounted
    aria-labelledby="alert-dialog-slide-title"
    aria-describedby="alert-dialog-slide-description"
  >

    <div style={{ textAlign: "center" }}>
      <ErrorDialog err={sendTwoFactor.err}></ErrorDialog>
      <ErrorDialog err={confirmTwoFactor.err}></ErrorDialog>
      <ProgressView status={sendTwoFactor.status} showError={false}>
        <ProgressView status={confirmTwoFactor.status} showError={false}>
          {status == TwoFactorStatus.register && (
            <Fragment>
              <DialogContent>
                {twoFactorRequired == true && (
                  <DialogContentText>
                    <span style={{ color: "red" }}>
                      <Trans
                        i18nKey="twoFactor.mustSetupTwoFactor"
                        values={{
                          site: `<strong>${currentSite}</strong>`,
                        }}
                      />
                    </span>
                  </DialogContentText>
                )}
                {twoFactorRequired == false && (
                  <DialogContentText>
                    {t("twoFactor.setupTwoFactor")}
                  </DialogContentText>
                )}
                <div style={{ marginTop: 40 }}>
                  <DialogContentText>
                    <b>{t("twoFactor.enterMobNo")}</b>
                  </DialogContentText>
                  <DialogContentText>
                    {t("twoFactor.deviceNeeded")}
                  </DialogContentText>
                </div>
                <div style={{ marginTop: 40 }}>
                  <TextInputField label={t("booking.labels.phoneMobile")} onChange={(value) => {
                    setMobile(value);
                  }} value={mobile}></TextInputField>
                </div>
              </DialogContent>
              <DialogActions>
                <Button onClick={() => {
                  props.onClose();
                }} color="primary">{twoFactorRequired == true ? t("menuItems.logout") : t("general.cancel")}</Button>

                <Button disabled={mobile.length == 0} onClick={() => {
                  sendTwoFactor.send(session.current.context, {
                    mobile: mobile
                  }, (result) => {
                    if (result) {
                      setStatus(TwoFactorStatus.confirmCode);
                    }
                  });
                }} color="primary">{t("general.next")}</Button>

              </DialogActions>
            </Fragment>
          )}

          {status == TwoFactorStatus.confirmCode && (
            <Fragment>
              <DialogContent>
                <DialogContentText>
                  {t("twoFactor.checkMob", { phone: mobile })}
                </DialogContentText>

                <DialogContentText>
                  <b>{t("twoFactor.enterCode")}</b>
                </DialogContentText>
                <div style={{ marginTop: 40 }}>
                  <TextInputField label={t("twoFactor.activationCode")} onChange={(value) => {
                    setCode(value);
                  }} value={code}></TextInputField>
                </div>

              </DialogContent>
              <DialogActions>
                <Button onClick={async () => {
                  setCode("");
                  setStatus(TwoFactorStatus.register);
                }} color="primary">{t("general.back")}</Button>

                <Button disabled={code.length == 0} onClick={async () => {

                  await confirmTwoFactor.send(session.current.context, {
                    mobile: mobile,
                    code: code
                  }, (result) => {
                    if (result) {
                      setStatus(TwoFactorStatus.finish);
                    }
                  });
                }} color="primary">{t("general.confirm")}</Button>

              </DialogActions>
            </Fragment>
          )}


          {status == TwoFactorStatus.finish && (
            <Fragment>
              <DialogContent>

                <DialogContentText>
                  <div>
                    {t("twoFactor.accountNowProtected")}
                  </div>
                  <div style={{ marginTop: 20 }}>
                    <b>{t("twoFactor.loginAgain")}</b>
                  </div>
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button onClick={async () => {
                  session.logout()
                }} color="primary">{t("general.close")}</Button>
              </DialogActions>
            </Fragment>
          )}
        </ProgressView>
      </ProgressView>
    </div>
  </Dialog>
}
TwoFactorRegistration.propTypes = {
  onClose: propTypes.func.isRequired,
  show: propTypes.bool.isRequired
}

export default TwoFactorRegistration;